import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import TableHead from '@mui/material/TableHead';
import { Button, TableSortLabel, Tooltip, useTheme } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { HeaderCells, Sort } from '../../types/ui';
import { important } from '../../utils/global/helper';

interface Props {
  cells: HeaderCells;
  sort?: Sort;
  small?: boolean;
}

export default function ReuseableTableHeader({ cells, sort, small }: Props) {
  const theme = useTheme();

  const onSort = (orderBy: string) => {
    if (!sort) return;
    sort.onSort(orderBy);
  };

  return (
    <TableHead>
      <TableRow>
        {cells.map(cell => (
          <TableCell
            component="th"
            scope="header"
            key={cell.id}
            sx={{
              paddingY: small ? important(theme.spacing(2.5)) : undefined,
            }}>
            <TableSortLabel
              disabled={!sort || !sort.sortableKeys?.includes(cell.id)}
              active={cell.id === sort?.orderBy}
              direction={cell.id === sort?.orderBy ? sort.order : 'asc'}
              onClick={() => onSort(cell.id)}>
              {cell.label}
            </TableSortLabel>
            {cell.tooltip && (
              <Tooltip title={cell.tooltip} arrow placement="top">
                <Button
                  onMouseOver={e => e.stopPropagation()}
                  variant="text"
                  color="inherit"
                  sx={{
                    pointerEvents: 'auto',
                    padding: 0,
                    border: 'none',
                    width: 'auto',
                    minWidth: 0,
                    flexShrink: 1,
                    ':hover': {
                      backgroundColor: 'transparent',
                    },
                  }}>
                  <InfoOutlinedIcon fontSize="small" />
                </Button>
              </Tooltip>
            )}
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}
